<template>
  <div class="d d_cy">
   <statistics-item
      title="少工委主任配备情况统计"
      :list="sortFn(list.sgwDirectorJobData, 'type', yORn, 10)"
      :type="10"
      :base="yORn"
    />
    <statistics-item
      title="针对五年内召开少代会"
      :list="sortFn(list.sgwMeeting5YearData, 'type', meetingList, 22)"
      :type="22"
      :base="meetingList"
    />
      <statistics-item
      title="针对三年内召开少代会"
      :list="sortFn(list.sgwMeeting3YearData, 'type', meetingList, 9)"
      :type="23"
      :base="meetingList"
    />

   <statistics-item
      title="本级校外辅导员资源库人数"
      :list="sortFn(list.outSideCounselorData, 'type', [], 11)"
      :type="11"
      :base="[]"
      :roleId="roleId"
    />

    <statistics-item
      title="总辅导员政治面貌"
      :list="sortFn(list.zzmmData, 'type', zzmmList, 1)"
      :type="1"
      :base="zzmmList"
    />

    <statistics-item
      title="是否设置少先队总辅导员"
      :list="sortFn(list.isCounselorData, 'type', yORn, 24)"
      :type="24"
      :base="yORn"
    />

    <statistics-item
      title="总辅导员编制所在单位"
      :list="sortFn(list.companyData, 'type', companyList, 1)"
      :type="1"
      :base="companyList"
    />
    <statistics-item
      title="总辅导员行政级别"
      :list="sortFn(list.administrativeLevelData, 'type', administrationList, 1)"
      :type="1"
      :base="administrationList"
    />
    <statistics-item
      title="总辅导员岗位类型"
      :list="sortFn(list.postTypeData, 'type', postTypeList, 1)"
      :type="1"
      :base="postTypeList"
    /> 
  </div>
</template>
<script>
import _ from "lodash";
import { reactive, toRefs } from "vue";
import {
  administrationList,
  companyList,
  postTypeList,
  zzmmList,
  meetingList,
} from "@/common/js";
import { yORn } from "@/common/js/field";
import StatisticsItem from "@/components/StatisticsItem";
export default {
  props: {
    list: Object,
  },
  components: {
    StatisticsItem,
  },
  setup(props) {
    const state = reactive({
      newList: props.list,
    });
    const sortFn = (list, key, base, type) => {
      if (list && list.length > 0) {
        if (type == 1) {
          for (let i = 0; i < base.length; i++) {
            const res = list.filter((res) => res[key] == base[i].key);
            if (res.length == 0) {
              list.push({ type: base[i].key, total: 0 });
            }
          }
        } else if (type == 9) {
          let newArr = [];
          for (let i of base) {
            const res = list.filter((r) => r.date == i.key);
            let total = 0;
            if (res.length > 0) {
              total = res[0].total;
            }
            newArr.push({
              value: i.value,
              total,
              type: i.key,
            });
          }

          return newArr;
        } else if(type == 10) {
          const groupArr = _.groupBy(list, 'levelSGWDirector')
          console.log('groupArr', groupArr)
          return groupArr
        } else if (type == 22) {
          const groupArr = _.groupBy(list, 'roleId')
          return groupArr
        } else if(type == 24) {
           const groupArr = _.groupBy(list, 'roleId')
          return groupArr
        }

        return list.sort(compare(key));
      } else {
        if (!base) {
          return [];
        }
        if (type != 9) {
          let arr = [];
          for (let item of base) {
            // console.log("item", item);
            arr.push({ type: item.key, total: 0 });
          }
          return arr;
        }
        if (type == 9) {
          let newArr = [];
          for (let i of base) {
            newArr.push({
              value: i.value,
              total: 0,
              type: i.key,
            });
          }
          return newArr;
        }

        return [];
      }
    };
    const compare = (property) => {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    };

    return {
      ...toRefs(state),
      sortFn,
      administrationList,
      companyList,
      yORn,
      postTypeList,
      zzmmList,
      meetingList,
    };
  },
};
</script>
<style lang="less" scoped></style>
